import { useQuery } from '@tanstack/react-query';

import { getActiveIntegrationTokensForProject } from '@/features/integrations/api/get-integration-tokens';
import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';

export const ACTIVE_PROJECT_INTEGRATION_TOKENS_QUERY_KEY =
  'activeProjectIntegrationTokens';

export function useActiveProjectIntegrationTokens(projectId: number) {
  const currentOrgId = useCurrentOrgId();

  return useQuery({
    queryKey: [
      ACTIVE_PROJECT_INTEGRATION_TOKENS_QUERY_KEY,
      currentOrgId,
      projectId,
    ],
    queryFn: () =>
      getActiveIntegrationTokensForProject(currentOrgId ?? 0, projectId),
    enabled: !!currentOrgId && !!projectId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
